import {
  SupplierContactGetters,
  SupplierContactMutations,
  SupplierContactActions
} from './supplier-contact-details.keys';
import { supplierContactService } from './supplier-contact-details.service';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import { TolMessagesActions } from '@/app/features/tol-messages/tol-messages.keys';
import router from '@/router';

export const getDefaultState = () => {
  return {
    supplierContactDetails: {
      user: {},
      suppliers: []
    }
  };
};
export const supplierContactDetailsStore = {
  state: getDefaultState,
  getters: {
    [SupplierContactGetters.GetSupplierContact]: state => state.supplierContactDetails
  },
  mutations: {
    [SupplierContactMutations.SetSupplierContact](state, supplierContact) {
      state.supplierContactDetails = supplierContact;
    }
  },
  actions: {
    [SupplierContactActions.GetSupplierContact]({ commit }, reference_number) {
      supplierContactService.getSupplierContact(reference_number).then(response => {
        commit(SupplierContactMutations.SetSupplierContact, response.data);
      });
    },
    [SupplierContactActions.SaveSupplierContact]({ dispatch }, supplierContact) {
      supplierContactService.saveSupplierContact(supplierContact).then(status => {
        dispatch(TolErrorsActions.ClearAll);
        if (status && status.message === 'success') {
          dispatch(SupplierContactActions.GetSupplierContact, status.data).then(
            router
              .push({ name: 'supplier-contact-details', params: { id: status.data } })
              .catch(() => {})
          );
          if (status.info) {
            dispatch(TolMessagesActions.SetMessages, status.info);
          }
        } else {
          dispatch(TolMessagesActions.ClearAll);
          const messages = Object.values(status.errors);
          let items = [];
          for (let item of messages) {
            items = items.concat(item);
          }
          dispatch(TolErrorsActions.SetError, { items });
        }
      });
    }
  }
};
